import { useId } from 'react';
import type { JobStatus } from '@/lib/types';

interface StatusFilterProps {
  value: JobStatus | 'all';
  onChange: (status: JobStatus | 'all') => void;
}

const statusOptions: { value: JobStatus | 'all'; label: string }[] = [
  { value: 'all', label: 'All Statuses' },
  { value: 'pending', label: 'Pending' },
  { value: 'running', label: 'Running' },
  { value: 'completed', label: 'Completed' },
  { value: 'failed', label: 'Failed' },
  { value: 'cancelled', label: 'Cancelled' },
  { value: 'expired', label: 'Expired' },
  { value: 'retry_pending', label: 'Retry Pending' },
];

export default function StatusFilter({ value, onChange }: StatusFilterProps) {
  const selectId = useId();
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={selectId} className="text-sm font-medium text-muted-foreground">Status</label>
      <select
        id={selectId}
        value={value}
        onChange={(e) => onChange(e.target.value as JobStatus | 'all')}
        className="px-3 py-2 rounded-md bg-background border border-border text-sm outline-none focus:border-primary transition-colors cursor-pointer"
      >
        {statusOptions.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
}
